module.exports = __webpack_public_path__ + "static/waiting-796722b3901fa4dcc7282fa62bbb2bae.svg";